export default __webpack_public_path__ + "static/media/person.6636cfb8.png";